<div [hidden]="!isActive">
  <ng-content></ng-content>
</div>
